import { memo } from 'react';
import UIAlert from 'UIComponents/alert/UIAlert';
import { jsx as _jsx } from "react/jsx-runtime";
function CallMetadataError({
  children,
  className
}) {
  return /*#__PURE__*/_jsx(UIAlert, {
    "data-test-id": "call-metadata-error",
    type: "warning",
    use: "inline",
    className: className,
    children: children
  });
}
export default /*#__PURE__*/memo(CallMetadataError);